module.exports = __webpack_public_path__ + "media/alerta-caixa.ba88f276.mp3";